import { render, staticRenderFns } from "./produto-vinculo.vue?vue&type=template&id=0168fa3d&"
import script from "./produto-vinculo.vue?vue&type=script&lang=js&"
export * from "./produto-vinculo.vue?vue&type=script&lang=js&"
import style0 from "./produto-vinculo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports